<!--
Voting ballot box screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Enter Preferences" :home="true" />
  <VoteConfirm ref="voteConfirm" />
  <div class="vContainer">
    <p class="votingHdr">{{this.election.name}}</p>
    <p class="votingInstructions">
      Enter number <b>1</b> against your most preferred candidate, <b>2</b> against your second,
      and so on for as many candidates as you wish to vote for.
    </p>
  </div>
  <div style="border-top:1px solid #e4e4e4;border-bottom:1px solid #e4e4e4;margin-bottom:24px;">
        <p class="votingSeatHdr">Total of {{this.election.numberOfSeats}} seat<span v-if="this.election.numberOfSeats>1">s</span> available</p>
  </div>
  <div class="vContainer">
        <div v-if="invalidFlag">
              <p style="color:#B30C00;font-weight:bold;">The ballot paper has invalid values. Please try again.</p>
        </div>
        <form target="_blank" method="POST" name="voteForm" autocomplete="off" >
        <ul class="list-group menuUl">
          <Candidate v-for="(candidate,index) in candidates" :key="index" :i="index" :candidate="candidate"/>
          </ul>

            <input type="button" value="Submit Vote" id="submitVote" @click="vote" class="list-group-item list-group-item-primary voteButton"/>
            <input type="button" value="Spoil Vote" id="spoilVote" @click="spoil" class="list-group-item list-group-item-primary voteButton"/>

          <input type="hidden" name="submitButton" id="submitButton" value="" />
          <input type="hidden" name="clientToken" id="clientToken" :value="this.token" />
        </form>
        <div style="margin-top:16px;text-align:center;">
          <a style="color:#003865;font-weight:bold;" target="_blank" href="https://glasgow.saasiteu.com/Modules/SelfService/Login.aspx?ProviderName=University%20of%20Glasgow&Tab=ServiceCatalog&CommandId=NewServiceRequestByOfferingId&Template=DCCA5F9724D34B7687ECD59F0577726C">Contact the UofG Helpdesk</a>
        </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import VoteConfirm from '@/components/VoteConfirm.vue'
import Candidate from '@/components/voting/Candidate.vue'
export default {
  name: 'VotingBallotBox',
  components: {
    VoteConfirm,
    Candidate
  },
  data () {
    return {
      candidates: {},
      election: {},
      token: {},
      invalidFlag: false
    }
  },
  mounted () {
    axios.get('/vote/rest/ballotbox?electionId=' + this.$route.query.electionId)
      .then(response => {
        this.candidates = {}
        this.election = {}
        this.token = {}
        this.election = response.data['election']
        this.candidates = response.data['candidates']
        this.token = response.data['token']
      })
  },
  methods: {

    createData () {
      this.candidateInfo = {}
      this.data = {}

      for (var i = 0; i < this.candidates.length; i++) {
        this.candidateInfo['candidate' + i] = document.getElementsByName('candidate' + i)[0].value
        this.candidateInfo['candidateBox' + i] = document.getElementsByName('candidateBox' + i)[0].value
      }

      this.data['submitButton'] = document.getElementsByName('submitButton')[0].value
      this.data['clientToken'] = document.getElementsByName('clientToken')[0].value
      this.data['candidateInfo'] = this.candidateInfo
    },

    submitForm () {
      axios.post('/vote/rest/ballotbox', this.data)
        .then(response => {
          if (response.data == 'OK') {
            this.$router.push('/voting/confirmation')
          } else {
            this.invalidFlag = true
          }
        })
        .catch(() => {
          this.alert('You have timed out.', this.$router.push('/voting/login'))
        })
    },

    closeModal() {
      var modal = document.getElementById('voteConfirmModal')
      const greybg = document.querySelector(".modal-backdrop.fade.show")
      greybg.classList.remove("show");
      document.body.classList.remove("modal-open");
      modal.setAttribute("aria-hidden", "true");
      modal.classList.remove("show");
      modal.style.display = "none";
      greybg.remove();
    },

    vote () {
      document.getElementById('submitVote').disabled = true
      document.getElementById('spoilVote').disabled = true
      this.$refs.voteConfirm.show('Are you sure you want to submit your vote?',
        () => {
          document.getElementById('submitButton').value = 'Submit Vote'
          this.createData()
          this.closeModal()
          this.submitForm()
          document.getElementById('submitVote').removeAttribute('disabled')
          document.getElementById('spoilVote').removeAttribute('disabled')
        },
        () => {
          this.closeModal()
          document.getElementById('submitVote').removeAttribute('disabled')
          document.getElementById('spoilVote').removeAttribute('disabled')
        }
      )
    },

    spoil () {
      document.getElementById('submitVote').disabled = true
      document.getElementById('spoilVote').disabled = true
      this.$refs.voteConfirm.show('Are you sure you want to spoil your vote?',
        () => {
          document.getElementById('submitButton').value = 'Spoil Vote'
          this.createData()
          this.closeModal()
          this.submitForm()
        },
        () => {
          this.closeModal()
          document.getElementById('submitVote').removeAttribute('disabled')
          document.getElementById('spoilVote').removeAttribute('disabled')
        }
      )
    }

  }
}
</script>
<style>
.votingInputBox {
  float:right;
  width:48px;
  height:48px;
  background: rgba(118, 118, 128, 0.12);
  border-radius: 10px;
  border: 1px solid rgba(118, 118, 128, 0.12);
  text-align:center;
}
.votingInstructions {
  text-align:left;
  padding:auto;
  color: #4F5961;
}

.votingContainer {
  padding-left:5%;
  padding-right:5%;
  text-align:center;
}

.votingHdr {
  margin-top:10px;
  margin-bottom:10px;
  font-weight:bold;
  color: #003865; /* #686868 */
}

.votingSeatHdr {
  font-weight:bold;
  color:  #003865;
  margin-bottom:8px;
  margin-top:8px;
  margin-left:24px;
}

.voteButton {
  width:100%;
}

.voteButton:focus {

  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

#submitVote {
  border: 1px solid #003865;
  background-color:#003865;
  color:#ffffff;
  font-weight:700;
  border-radius:12px;
  margin-bottom:12px;
  margin-top:14px; /* 10 + 14 = 24 , TODO should write first/last child css methods */
}

#spoilVote {
  border: 1px solid #003865;
  background-color:#ffffff;
  color:#003865;
  font-weight:700;
  border-radius:12px;

}

.votingCandidate {
  height:72px;
  text-align:left;
  margin-bottom:10px;
  border: 1px solid #e4e4e4 !important;
  border-radius:24px !important;
  font-size:16px;
  font-weight:700;
}

#prefError {
  background-color: #FE416D;
  border: 1px solid #DE0663 !important;
  color:#ffffff;
  border-radius:6px !important;
}
</style>
